import { getSafeAreaPaddings } from "@clipboard-health/ui-theme";
import { Box } from "@mui/material";

import { IconButton } from "../components/IconButton";

interface ShareInsightButtonProps {
  isSharing: boolean;
  handleShare: () => Promise<void>;
}

export function ShareInsightButton(props: ShareInsightButtonProps) {
  const { isSharing, handleShare } = props;

  return (
    <Box
      sx={(theme) => ({
        position: "absolute",
        right: theme.spacing(5),
        bottom: 0,
        ...getSafeAreaPaddings({
          bottom: true,
          fallbackBottom: theme.spacing(5),
        }),
      })}
    >
      <IconButton
        iconType="plane"
        variant="contained"
        size="large"
        disabled={isSharing}
        onClick={async () => {
          await handleShare();
        }}
      />
    </Box>
  );
}
